import React, { Component } from 'react';
import { connect } from 'react-redux';
import withModal from '../../../../lib/hoc/withModal';
import { appActions } from '../../../../store/modules/app';
import { couponActions } from '../../../../store/modules/coupon';
import GenerateCouponValidFailModal from '../../../../views/app/common/modal/GenerateCouponValidFailModal';

/**
 *  쿠폰 발급 유효 체크 실패 모달
 */
class GenerateCouponValidFailModalContainer extends Component {
  /**
   * 모달 닫기
   */
  closeModal = () => {
    this.props.appToggleModal({
      name: 'generateCouponValidFailModal',
      value: false,
    });
  };

  /**
   * 엑셀 일괄 발급 모달 열기
   */
  openExcelBulkGenerateCouponModal = () => {
    this.props.toggleModal({
      name: 'excelBulkGenerateCouponModal',
      value: true,
    });

    /**
     *  모달 닫기
     */
    this.closeModal();
  };

  render() {
    const { isOpen, data } = this.props;

    return (
      <GenerateCouponValidFailModal
        isOpen={isOpen}
        data={data}
        openExcelBulkGenerateCouponModal={this.openExcelBulkGenerateCouponModal}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.generateCouponValidFailModal.isOpen,
    data: state.app.generateCouponValidFailModal.data,
  };
};

const mapDispatchToProps = {
  appToggleModal: appActions.appToggleModal,
  toggleModal: couponActions.toggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(GenerateCouponValidFailModalContainer));
